import React from 'react';
import { ChatSidebar } from './ChatSidebar';
import { ChatContent } from './ChatContent';
import { useChatContext } from '@/contexts/ChatContext';
import { cn } from '@/lib/utils';

interface ChatDesktopProps {
  onRequestCloseSidebar?: () => void;
}

export const ChatDesktop: React.FC<ChatDesktopProps> = ({ onRequestCloseSidebar }) => {
  const { isSidebarOpen, closeSidebar } = useChatContext();
  const handleRequestClose = onRequestCloseSidebar ?? closeSidebar;

  return (
    <div className="relative flex h-full">
      <div className="flex flex-1">
        <div
          className={cn(
            'h-full transition-all duration-200 ease-out overflow-hidden',
            isSidebarOpen ? 'w-80' : 'w-0'
          )}
        >
          <ChatSidebar onRequestClose={handleRequestClose} />
        </div>

        {/* Main Chat Content Area */}
        <div className="flex-1 min-w-0">
          <ChatContent className="h-full justify-center rounded-xl bg-[#121212]" />
        </div>
      </div>
    </div>
  );
};
